var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.getButtonClassList(),style:({background: _vm.bg_color}),attrs:{"type":_vm.type}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }